export default class Heroform {
    constructor() {
        this.amount = 0;

        // Initial fieldset
        this.changeHandler();

        // Step1 - On radio interval or type change
        Array.prototype.forEach.call(document.querySelectorAll('input[type=radio][name="Interval"], input[type=radio][name="TypeOfDonation"]'),  (trigger) => {
            trigger.addEventListener('change', () => this.changeHandler());
        });

        // Step1 - On amount radio change:
        Array.prototype.forEach.call(document.querySelectorAll('.variable-input input[type="radio"]'), (trigger) => {
            trigger.addEventListener('change', () => this.radioAmountChange());
        });

        // Step1 - On other amount change:
        Array.prototype.forEach.call(document.querySelectorAll('input.other-amount'), (trigger) => {
            trigger.addEventListener('keyup', () => this.otherAmountChange());
        });

        // On next step klik:
        Array.prototype.forEach.call(document.querySelectorAll('.nextsteptrigger'), (trigger) => {
            trigger.addEventListener('click', () => this.stepSwitch());
        });

        // On prev step klik:
        Array.prototype.forEach.call(document.querySelectorAll('.prevsteptrigger'), (trigger) => {
            trigger.addEventListener('click', () => this.goToPrevStep());
        });

        // Step3 - On other donation reason:
        Array.prototype.forEach.call(document.querySelectorAll('#DonationForm_DonationForm_DonationReason_Geinteresseerd'), (trigger) => {
            trigger.addEventListener('change', () => this.donationReasonChange());
        });
    }

    changeHandler() {
        // Amount reset:
        var radiostoreset = document.querySelectorAll('.variable-input input[type=radio]:checked');
        for (var i = 0; i < radiostoreset.length; i++) {
            radiostoreset[i].checked = false;
        }

        var otherAmountField = document.querySelector('input.other-amount');
        otherAmountField.value = '';

        this.amount = "";

        // Set interval value
        var intervalRadio = document.querySelector('input[type="radio"][name="Interval"]:checked');

        // Set type of donation value
        var typeOfDonationRadio = document.querySelector('input[type="radio"][name="TypeOfDonation"]:checked');

        // Combine values to usable classes
        var elementToActive = '.' + intervalRadio.value.toLowerCase() + '-' + typeOfDonationRadio.value.toLowerCase();
        var stepPathClass = '.' + typeOfDonationRadio.value.toLowerCase() + '-' + intervalRadio.value.toLowerCase();


        // Disable monthly business:
        if (typeOfDonationRadio.value.toLowerCase() == 'business') {
            document.querySelector('#DonationForm_DonationForm_Interval_Holder').classList.add('no-monthly');
        }else {
            document.querySelector('#DonationForm_DonationForm_Interval_Holder').classList.remove('no-monthly');
        }

        this.changeToActive(elementToActive);

        this.setStepPath(stepPathClass);

        this.setStepParts(stepPathClass);
    }

    donationReasonChange() {
        if (document.querySelector('#DonationForm_DonationForm_DonationReason_Geinteresseerd:checked')) {
            const reasontextfield = document.querySelectorAll('.donation-reason-other');
            for (var i = 0; i < reasontextfield.length; i++) {
                reasontextfield[i].classList.add('active');
            }
        } else {
            const reasontextfield = document.querySelectorAll('.donation-reason-other');
            for (var i = 0; i < reasontextfield.length; i++) {
                reasontextfield[i].classList.remove('active');
            }
        }
    }

    amountPasstrough() {
        var amountElement = document.querySelector('.amount-passtrough');
        amountElement.innerHTML = this.amount;
    }

    radioAmountChange() {
        var otherAmountField = document.querySelector('input.other-amount');
        otherAmountField.value = '';

        var selectedValue = document.querySelector('.variable-input.active input[type=radio]:checked').value
        this.amount = selectedValue;

        this.amountPasstrough();
    }

    otherAmountChange() {
        var radiostoreset = document.querySelectorAll('.variable-input input[type=radio]:checked');
        for (var i = 0; i < radiostoreset.length; i++) {
            radiostoreset[i].checked = false;
        }

        var filledInValue = document.querySelector('#DonationForm_DonationForm_OtherAmount').value
        
        this.amount = filledInValue;

        // Only allow numbers and higher than 1:
        var allowedChars = /^[0-9,.]*$/;

        if (!filledInValue.match(allowedChars) || parseInt(this.amount) < 1) {
            document.querySelector('#DonationForm_DonationForm_OtherAmount').value = '';
            this.amount = '';
        }
        this.amountPasstrough(this.amount);
    }

    changeToActive(classname) {
        // Remove current actives:
        var oldactives = document.querySelectorAll('.variable-input.active');
        for (var i = 0; i < oldactives.length; i++) {
            oldactives[i].classList.remove('active');
        }

        // Set new active:
        var divs = document.querySelectorAll('.variable-input' + classname);

        for (var i = 0; i < divs.length; i++) {
            divs[i].classList.add('active');
        }
    }

    setStepPath(classname) {
        // Remove current steppath:
        var oldactives = document.querySelectorAll('.stepcontainer.steppath');
        for (var i = 0; i < oldactives.length; i++) {
            oldactives[i].classList.remove('steppath');
        }

        var divs = document.querySelectorAll('.stepcontainer' + classname);

        for (var i = 0; i < divs.length; i++) {
            divs[i].classList.add('steppath');
        }

        // First step is allways part of steppath:
        document.getElementById('firstGlobalStep').classList.add('steppath');

        // Set stepcounter to amount of steps:
        document.querySelector('.stepcounter .totalsteps').innerHTML = document.querySelectorAll('#DonationForm_DonationForm .steppath').length;
    }

    setStepParts(classname) {
        // Deactivate current stepparts:
        var oldactives = document.querySelectorAll('.step-part.active');
        for (var i = 0; i < oldactives.length; i++) {
            oldactives[i].classList.remove('active');
        }

        // Activate new stepparts:
        var divs = document.querySelectorAll('.step-part' + classname);
        for (var i = 0; i < divs.length; i++) {
            divs[i].classList.add('active');
        }
    }

    stepSwitch() {
        if (this.validateFields()) {
            this.goToNextStep();

            if (window.innerWidth <= 1024) {
                document.querySelector('.stepcounter').scrollIntoView({
                    behavior: 'smooth'
                });
            }
        }
    }

    validateFields() {
        // Check if requireds are filled:
        var validation = true;

        if (!this.amount) {
            validation = false;
        }

        // All required text fields:
        var requiredTextFields = document.querySelectorAll('.stepcontainer.active input.required[type=text]');

        requiredTextFields.forEach((el, index, fullArray) => {
            if (!el.value) {
                validation = false;
            }
        });

        // All required checkboxes:
        var requiredCheckFields = document.querySelectorAll('.stepcontainer.active .required.checkbox input.checkbox');

        requiredCheckFields.forEach((el, index, fullArray) => {
            if (!el.checked) {
                validation = false;
            }
        });

        const requiredEmailField = document.querySelector('.stepcontainer.active .required #DonationForm_DonationForm_Email');
        if (requiredEmailField) {

            var emailRegEx = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

            if (!emailRegEx.test(requiredEmailField.value)) {
                validation = false;
            }
        }

        const requiredIbanField = document.querySelector('.stepcontainer.active .required #DonationForm_DonationForm_IBAN');
        if (requiredIbanField) {

            var ibanRegex = /^([A-Z]{2}[ \-]?[0-9]{2})(?=(?:[ \-]?[A-Z0-9]){9,30}$)((?:[ \-]?[A-Z0-9]{3,5}){2,7})([ \-]?[A-Z0-9]{1,3})?$/;

            if (!ibanRegex.test(requiredIbanField.value)) {
                validation = false;
            }
        }

        // Specific required contactmethod:
        if (document.querySelector('.stepcontainer.active .variable-required.active')) {
            var requiredContactMethod = document.querySelector('.stepcontainer.active .required.optionset input.radio[name=ContactMethod]:checked');
            if (!requiredContactMethod) {
                validation = false;
            }
        }

        // Control error melding:
        var errormelding = document.querySelector('.btn-toolbar .error');

        if (!validation) {
            if (errormelding.classList.contains('active')) {
                errormelding.classList.add('alert');
                setTimeout(function () {
                    errormelding.classList.remove('alert');
                }, 500);
            } else {
                errormelding.classList.add('active');
            }
        } else {
            errormelding.classList.remove('active');
        }

        if (validation) {
            return true;
        } else {
            return false;
        }
    }

    goToNextStep() {
        // Update stepcounter:
        const totalsteps = document.querySelector('.stepcounter .totalsteps').innerHTML;
        var currentstepnumber = document.querySelector('.stepcounter .currentstep').innerHTML;

        var nextstep = parseInt(currentstepnumber) + 1;

        if (nextstep > totalsteps) {
            const event = document.querySelector('#DonationForm_DonationForm_TypeOfDonation input[type=radio]:checked').value;
            const freq = document.querySelector('#DonationForm_DonationForm_Interval input[type=radio]:checked').value;
            const amount = document.querySelector('.amount-passtrough').innerHTML;
            
            window.dataLayer.push({
                'event': 'Donation' + event,
                'frequentie': freq,
                'bedrag': amount
            });

            document.getElementById('DonationForm_DonationForm').submit();
        }else {
            document.querySelector('.stepcounter .currentstep').innerHTML = nextstep;

            this.updateToolbar(currentstepnumber, nextstep, totalsteps);

            // Set current step inactive
            var oudestep = document.querySelector('.stepcontainer.steppath.active');
            oudestep.classList.remove('active');

            // Set next step to active
            var steps = document.querySelectorAll('.stepcontainer.steppath');

            steps.forEach((el, index, fullArray) => {
                if (index == currentstepnumber) {
                    el.classList.add('active');
                } 
            });
        }
    }

    goToPrevStep() {
        // Update stepcounter:
        const totalsteps = document.querySelector('.stepcounter .totalsteps').innerHTML;
        var currentstepnumber = document.querySelector('.stepcounter .currentstep').innerHTML;

        var prevstep = parseInt(currentstepnumber) - 1;

        document.querySelector('.stepcounter .currentstep').innerHTML = prevstep;

        // Als we de laatste stap verlaten:
        this.updateToolbar(currentstepnumber, prevstep, totalsteps);

        // Set current step inactive
        var oudestep = document.querySelector('.stepcontainer.steppath.active');
        oudestep.classList.remove('active');

        // Set next step to active
        var steps = document.querySelectorAll('.stepcontainer.steppath');

        steps.forEach((el, index, fullArray) => {
            if (index == (prevstep - 1)) {
                el.classList.add('active');
            }
        });
    }

    updateToolbar(currentstep, gotostep, totalsteps) {
        const nextsteptrigger = document.querySelector('.btn-toolbar .nextsteptrigger');
        const prevsteptrigger = document.querySelector('.btn-toolbar .prevsteptrigger');
        const errormelding = document.querySelector('.btn-toolbar .error');

        nextsteptrigger.classList.add('active');
        prevsteptrigger.classList.add('active');
        errormelding.classList.remove('active');

        // Laatste stap:
        nextsteptrigger
        if (totalsteps == gotostep) {
            nextsteptrigger.innerHTML = 'Verstuur';
        }else {
            nextsteptrigger.innerHTML = 'Volgende stap';
        }

        // Eerste stap
        if (gotostep == 1) {
            prevsteptrigger.classList.remove('active');
        }
    }
}
